/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {Dataset} from './Dataset';
import {DatasetFromJSON, DatasetFromJSONTyped, DatasetToJSON} from './Dataset';

/**
 *
 * @export
 * @interface DatasetInfo
 */
export interface DatasetInfo {
  /**
   *
   * @type {boolean}
   * @memberof DatasetInfo
   */
  created: boolean;
  /**
   *
   * @type {number}
   * @memberof DatasetInfo
   */
  selectedRowIndex?: number | null;
  /**
   *
   * @type {Dataset}
   * @memberof DatasetInfo
   */
  data?: Dataset | null;
}

/**
 * Check if a given object implements the DatasetInfo interface.
 */
export function instanceOfDatasetInfo(value: object): value is DatasetInfo {
  if (!('created' in value) || value['created'] === undefined) return false;
  return true;
}

export function DatasetInfoFromJSON(json: any): DatasetInfo {
  return DatasetInfoFromJSONTyped(json, false);
}

export function DatasetInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetInfo {
  if (json == null) {
    return json;
  }
  return {
    created: json['created'],
    selectedRowIndex: json['selected_row_index'] == null ? undefined : json['selected_row_index'],
    data: json['data'] == null ? undefined : DatasetFromJSON(json['data'])
  };
}

export function DatasetInfoToJSON(value?: DatasetInfo | null): any {
  if (value == null) {
    return value;
  }
  return {
    created: value['created'],
    selected_row_index: value['selectedRowIndex'],
    data: DatasetToJSON(value['data'])
  };
}
